import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import processing from 'app/blocks/common/decorators/processing';
import Layout from 'app/blocks/Layout/Layout';
import * as middleware from 'app/blocks/middleware/middleware';

@autobind
class FunderPaidConfirmationMessage extends PureComponent {
    static propTypes = {
        articleId: PropTypes.string.isRequired,
        className: PropTypes.string,
    };

    static defaultProps = {
        className: undefined,
    };

    state = {
        isLoading: true,
        error: null,
        orderConfirmationMessage: '',
    };

    @processing('isLoading')
    async componentDidMount() {
        const { articleId } = this.props;

        try {
            this.setState({
                orderConfirmationMessage: await middleware.onlineopen.getFunderPaidSuccessMessage(articleId),
            });
        } catch (error) {
            this.setState({ error });
        }
    }

    render() {
        const { orderConfirmationMessage, isLoading, error } = this.state;

        return (
            <Layout className={this.props.className} error={error} isLoading={isLoading}>
                <div
                    dangerouslySetInnerHTML={{ __html: orderConfirmationMessage }}
                    data-seleniumid="orders-confirmation-text"
                />
            </Layout>
        );
    }
}

export default FunderPaidConfirmationMessage;
